/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartComboSchema } from "./banquetCartComboSchema.ts";
import { banquetCartItemSchema } from "./banquetCartItemSchema.ts";

export const banquetCartSchema = z
	.object({
		items: z.array(banquetCartItemSchema),
		combos: z.array(banquetCartComboSchema),
		is_complete: z.boolean().describe("false — на кассе есть позиции официанта, которые гость не может вернуть в корзину: менять состав нельзя"),
	})
	.describe("Состав банкета в формате корзины заказа: тело для замены состава как есть.");
